import React, { useEffect, useState } from 'react';
import { ORBIT_CONFIG, SCARCITY } from './orbitContent';
import './OrbitInterestForm.css';

const AGES = ['5', '6', '7', '8', 'Other'];
const AREAS = [
  'Gachibowli',
  'Madhapur',
  'Kondapur',
  'Hitech City',
  'Jubilee Hills',
  'Banjara Hills',
  'Secunderabad',
  'Other',
];
const SATURDAY = ['Yes', 'Maybe', 'No'];

const INITIAL = {
  parentName: '',
  childName: '',
  age: '6',
  area: 'Gachibowli',
  areaOther: '',
  saturdayOk: 'Yes',
};

/**
 * Light join: chips → WhatsApp.
 * Smart defaults on age / area / Saturday. No fake step pills.
 */
export default function OrbitInterestForm() {
  const [form, setForm] = useState(INITIAL);
  const [errorMsg, setErrorMsg] = useState('');
  const [opened, setOpened] = useState(false);

  useEffect(() => {
    if (window.location.hash === '#interest') {
      document.getElementById('interest')?.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  const set = (key, value) => setForm((f) => ({ ...f, [key]: value }));

  const areaValue =
    form.area === 'Other' ? form.areaOther.trim() || 'Other' : form.area;

  const validate = () => {
    if (!form.parentName.trim()) return 'Your name please';
    if (!form.childName.trim()) return 'Child’s first name please';
    if (form.area === 'Other' && !form.areaOther.trim()) {
      return 'Tell us your area (or nearest landmark)';
    }
    return '';
  };

  const buildMessage = () => {
    const lines = [
      'Hi! We want to start Orbit Month 1 with you (one of 5 families).',
      `Parent: ${form.parentName.trim()}`,
      `Child: ${form.childName.trim()} (age ${form.age})`,
      `Area: ${areaValue}`,
      `Saturday meetup: ${form.saturdayOk}`,
    ];
    return lines.join('\n');
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const problem = validate();
    if (problem) {
      setErrorMsg(problem);
      return;
    }
    setErrorMsg('');
    const href = `https://wa.me/${ORBIT_CONFIG.whatsappNumber}?text=${encodeURIComponent(buildMessage())}`;
    window.open(href, '_blank', 'noopener,noreferrer');
    setOpened(true);
  };

  if (opened) {
    return (
      <div className="oif oif-done" id="interest">
        <h3>Almost there</h3>
        <p className="oif-lead">
          Press <strong>Send</strong> in WhatsApp to finish.
        </p>
        <button
          type="button"
          className="m360-btn m360-btn-ghost"
          onClick={() => setOpened(false)}
        >
          Edit details
        </button>
      </div>
    );
  }

  return (
    <form className="oif" id="interest" onSubmit={onSubmit} noValidate>
      <h3>{SCARCITY.formTitle}</h3>
      <p className="oif-lead">{SCARCITY.formLead}</p>

      <label className="oif-field">
        <span>Your name</span>
        <input
          type="text"
          name="parentName"
          autoComplete="name"
          value={form.parentName}
          onChange={(e) => set('parentName', e.target.value)}
          placeholder="Parent first name"
          required
        />
      </label>

      <label className="oif-field">
        <span>Child’s first name</span>
        <input
          type="text"
          name="childName"
          value={form.childName}
          onChange={(e) => set('childName', e.target.value)}
          placeholder="What we call them"
          required
        />
      </label>

      <fieldset className="oif-field">
        <legend>Child’s age</legend>
        <div className="oif-chips" role="radiogroup" aria-label="Age">
          {AGES.map((age) => (
            <button
              key={age}
              type="button"
              className={`oif-chip${form.age === age ? ' is-on' : ''}`}
              aria-pressed={form.age === age}
              onClick={() => set('age', age)}
            >
              {age}
            </button>
          ))}
        </div>
      </fieldset>

      <fieldset className="oif-field">
        <legend>Nearest area</legend>
        <div className="oif-chips" role="radiogroup" aria-label="Area">
          {AREAS.map((area) => (
            <button
              key={area}
              type="button"
              className={`oif-chip${form.area === area ? ' is-on' : ''}`}
              aria-pressed={form.area === area}
              onClick={() => set('area', area)}
            >
              {area}
            </button>
          ))}
        </div>
        {form.area === 'Other' && (
          <input
            className="oif-follow"
            type="text"
            value={form.areaOther}
            onChange={(e) => set('areaOther', e.target.value)}
            placeholder="Neighbourhood or landmark"
          />
        )}
      </fieldset>

      <fieldset className="oif-field">
        <legend>Saturday morning meetup (~75 min)?</legend>
        <div className="oif-chips" role="radiogroup" aria-label="Saturday">
          {SATURDAY.map((opt) => (
            <button
              key={opt}
              type="button"
              className={`oif-chip${form.saturdayOk === opt ? ' is-on' : ''}`}
              aria-pressed={form.saturdayOk === opt}
              onClick={() => set('saturdayOk', opt)}
            >
              {opt}
            </button>
          ))}
        </div>
      </fieldset>

      {errorMsg && (
        <p className="oif-error" role="alert">
          {errorMsg}
        </p>
      )}

      <button type="submit" className="m360-btn m360-btn-primary oif-submit">
        {SCARCITY.ctaShort} on WhatsApp
      </button>
      <p className="oif-fine">{SCARCITY.formFine}</p>
    </form>
  );
}
